export const environment = {
  production: false,
  apiUrlMSAdminService: "https://admin-dev.gofixii.com/api",
  apiUrlMSCatalogService: "https://catalog-dev.gofixii.com/api",
  apiUrlMSCommunicationService: "https://communication-dev.gofixii.com/api",
  apiUrlMSIdentifyService: "https://identify-dev.gofixii.com/api",
  apiUrlMSPaymentService: "https://payment-dev.gofixii.com/api",
  apiUrlMSQuoteService: "https://quote-dev.gofixii.com/api",
  apiUrlMSRequestService: "https://request-dev.gofixii.com/api",
  cloudFrontUrl: "https://dlpmm4nle6dar.cloudfront.net",
  wssUrlMSCommunicationService: "https://communication-dev.gofixii.com",
};
